(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-popover"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hover-details]').forEach(details => {
    const summary = details.querySelector('summary');
    
    // Prevent default click behavior
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
    
    // Open on hover
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', '');
    });
    
    // Close when mouse leaves
    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
